<template>
  <div class="forum-discussion">
    <div class="forum-discussion-top">
        <div class="title">论坛研讨</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="forum-discussion-number">
        <div class="number-item">
            <div class="name">话题数</div>
            <div class="number">354</div>
        </div>
        <div class="number-item">
            <div class="name">评论数</div>
            <div class="number">354</div>
        </div>
        <div class="number-item">
            <div class="name">参与人数</div>
            <div class="number">1205</div>
        </div>
    </div>
    <div class="forum-discussion-list">
        <div class="discussition-item" v-for="(item,index) in discussionList" :key="item.id">
            <div class="item-top">
                <div class="rank">NO.{{ index + 1 }}</div>
                <div class="title">{{ item.title }}</div>
            </div>
            <div class="item-bottom">
                <div class="progress">
                    <el-progress class="rank-progress" :color="'#2B7FFF'" :define-back-color="'#00000000'" :percentage="item.progress" :show-text="false" :stroke-width="16" />
                    <div class="number">{{ item.number }}条评论</div>
                </div>
            </div>
        </div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
export default {
  name: 'forum-discussion',
  data() {
    return {
        discussionList:[
            {
                title:"猜猜这是什么植物？",
                progress:98,
                number:1921,
                id:1
            },
            {
                title:"亚运,“加油鸭”孵化成功了",
                progress:93,
                number:1821,
                id:2
            },
            {
                title:"从《不简单的杠杆》一课学习“教学评”的一体化",
                progress:88,
                number:1621,
                id:3
            },
            {
                title:"家庭趣味小实验",
                progress:78,
                number:1521,
                id:4
            },
            {
                title:"童心向党-传承红色基因",
                progress:58,
                number:1021,
                id:5
            }
        ]
    }
  },
  methods: {

  },
  mounted(){

  }
}
</script>
<style lang='scss' scoped>
.forum-discussion{
    width: 100%;
    height: 330px;
    padding: 0 15px;
    border: 1px solid #053882;
    position: relative;
    margin-bottom: 20px;
    // background: rgba(6,17,52,0.8);
    .forum-discussion-top{
        position: relative;
        text-align: center;
        margin-bottom: 15px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .forum-discussion-number{
        display: flex;
        align-items: center;
        justify-content: space-around;
        margin-bottom: 10px;
        .number-item{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            .name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
                margin-right: 5px;
            }
            .number{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
            }
        }
    }
    .forum-discussion-list{
        .discussition-item{
            padding: 8px 10px 0 10px;
            // background-color: rgba(39, 115, 230, 0.4);
            background: linear-gradient(90deg, rgba(39, 115, 230,0.4), transparent 40%, transparent);
            margin-bottom: 6px;
            .item-top{
                margin-bottom: 5px;
                display: flex;
                width: 100%;
                justify-content: flex-start;
                line-height: 14px;
                .rank{
                    font-size: 14px;
                    font-family: DingTalk JinBuTi;
                    font-weight: 400;
                    color: #6EA0D3;
                    margin-right: 10px;
                    width:35px;
                    font-weight: 600;
                }
                .title{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #6EA0D3;
                    width: calc(100% - 45px);
                    text-align: left;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
            .item-bottom{
                margin-left: 45px;
                display: flex;
                width: calc(100% - 45px);
                align-items: center;
                line-height: 16px;
                .progress{
                    display: flex;
                    width: 100%;
                    align-items: center;
                    justify-content: space-between;
                    .rank-progress{
                        width: calc(100% - 90px);
                    }
                    .number{
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #2773E6;
                    }
                }
            }
        }
        .discussition-item:last-child(){
            margin-bottom: 0;
        }
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>
<style lang="scss">

.forum-discussion{
  .forum-discussion-list{
    .discussition-item{
        .item-bottom{
            .progress{
                .el-progress-bar{
                    .el-progress-bar__outer{
                        background-color: transparent;
                        border-radius: 0;
                        .el-progress-bar__inner{
                            border-radius: 0;
                        }
                    }
                    .el-progress__text{
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #6EA0D3;
                    }
                }
            }
        }
    }
  }
}
</style>